<template>
  <div>
    <header class="main_header">
      <div class="left_div">
        <div class="logo logo_heading">
          <a href="/"><img src="https://www.sitepal.com/api/examples/images/logo.png" alt="SitePal"></a>
        </div>
      </div>
    </header>

    <table id="tblContainer" cellspacing="0" align="center" border="0">

      <tr>
        <td id="tdContent">
          <p class="feature_entire_heading text-center f-bold h2" align="center"><b>AI Agent With Text Input - Using Vue
              JS </b></p>
          <p class="feature_entire_heading text-center" align="center">In this example we demonstrate an AI Agent that
            responds to text input. <br> Read our <a class="selected_support" href="/docs/Implementing_Your_AI_Agent.pdf" target="_blank">technical note</a> to learn more. </p>

          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <td align="center" COLSPAN="2" class="feature_entire_heading text-center sayAi">
              <!-- ******************************* SITEPAL EMBED CODE START  ***********************  -->
              <SitePal embed='16851,360,480,"",1,1, 2695840, 0,1,1,"5c6fde06460aa8ab405bf4f13cf93cf0",0' />
              <!-- ******************************* SITEPAL EMBED CODE END  ***********************  -->
              <br>

              <form NAME="myForm" class="form" @submit="sayAudio">
                <input name="textToSay" id="myInput" value="" v-model="textToSay" class="form-control d-inline w-25">
                <input TYPE="button" ref="myButton" id="myButton" VALUE="Ask AI Engine" @click="sayAudio"
                  class="btn btn-primary"><br><br>

                <br><br>
              </form>
              <iframe ref="frameContent" id="simple-content" align="top" height="200" width="400"></iframe>
            </td>

            <tr align="middle">
              <td align="center" COLSPAN="2" class="feature_entire_heading text-center">
                <p>Real-time Artificial Intelligence Engine provides automatic Text and
                  Audio responses to the questions provided. </p>
                <p>The Audio is generated automatically via a Text To Speech engine according to the selected voice and
                  language.</P><br>
              </td>
            </tr>
          </table>
        </td>
      </tr>

    </table>
    <footer>
      <div class="footer-menu oddcast text-center">
        <ul class="w-50 m-auto ">
          <li class="w-100 f-bold ">Please feel free to use the source code of this page as an example.</li>
          <li>To view the source code of this page, <a href="/api/examples/vue-ai-text/Sitepal-vue-text-ai.zip"
              download="">download</a>
            souce code</li>
        </ul>
      </div>
    </footer>
  </div>
</template>

<script>
import SitePal from 'sitepal-vue'


export default {
  name: 'ThreeDCharacter',
  components: {
    SitePal
  },
  data() {
    return {
      textToSay: '',
      iframeContent: ''
    };
  },
  mounted() {
    window.vh_aiResponse = (aiString) => {
      if (!this.textToSay.trim()) {
        console.error('Input is empty');
        return;
      }

      let aiResponse = aiString;

      this.iframeContent = `<br><font color="#FF0000">Q - ${this.textToSay}</font><br><font color="#0000FF">A - ${aiResponse}</font>${this.iframeContent}`;

      // Update iframe content
      this.$refs.frameContent.contentDocument.open();
      this.$refs.frameContent.contentDocument.write(`<html><body bgcolor="#FFFFFF">${this.iframeContent}</body></html>`);
      this.$refs.frameContent.contentDocument.close();
      // Clear the input field
      this.textToSay = '';

      // Restore button opacity and pointer events
      this.$refs.myButton.style.opacity = '1';
      this.$refs.myButton.style.pointerEvents = 'unset';
    };
  },
  methods: {
    sayText: function (txt, voice, lang, engine) {
      window.sayText(txt, voice, lang, engine);
    },
    aiFunction: function () {
      if (document.getElementById('myInput').value != '') {
        document.getElementById("myButton").style.opacity = "0.5";
        document.getElementById("myButton").style.pointerEvents = "none";
      }
    },
    sayAudio: function (e) {
      e.preventDefault();
      var textToSay = document.getElementById('myInput').value.trim();
      window.sayAI(textToSay, 1, 1, 3);
      this.aiFunction();
    },
  },
};
</script>

<style scoped>
@import 'https://sitepal.com/api/examples/css/apiExample.css';

header {
  display: flex;
  border-bottom: 1px solid #ccc;
  padding: .5rem 1rem;

  p {
    margin-left: 1rem;
  }
}

nav {
  margin-left: auto;

  ul {
    list-style: none;
  }

  ul li {
    display: inline-flex;
    margin-left: 1rem;
  }
}
</style>